import { Block } from "../Block";
import { BoardContainer } from "../BoardContainer";
import { Niche } from "./Niche";

export class BlocksScrollingModel {

    public static readonly SCROLLING_SPEED = 15; 

    public scrolling: boolean;
    public blockScrollingData: {id: number, blockHeight: number, y: number, py: number} [];
    public framesToSlowDown: number;
    public success: boolean;
    public scrollingSpeed: number;

    private f: number;
    private resultBlockId: number;

    constructor(resultBlockId: number) {

        this.resultBlockId = resultBlockId;
    }

    public update(emulating: boolean): void {

        if (this.f < 60) {

            this.scrollingSpeed += .2;

            if (this.scrollingSpeed >= BlocksScrollingModel.SCROLLING_SPEED) {

                this.scrollingSpeed = BlocksScrollingModel.SCROLLING_SPEED;
            }
        }
        
        for (let i = 0; i < this.blockScrollingData.length; i++) {

            const block = this.blockScrollingData[i];
            block.y += this.scrollingSpeed;
        }

        if (this.blockScrollingData[0].y >= 4 * BoardContainer.CELL_SIZE * Block.SCALE_ON_DISPENSER) {

            const upperBlock = this.blockScrollingData[this.blockScrollingData.length - 1];
            const lowerBlock = this.blockScrollingData.shift();

            lowerBlock.y = upperBlock.y; 
            lowerBlock.y -= (lowerBlock.blockHeight + 1) * BoardContainer.CELL_SIZE * Block.SCALE_ON_DISPENSER;

            this.blockScrollingData.push(lowerBlock);

            if (!emulating) {
                Niche.currentInstance.playTickAudioEffect();
            }
        }

        this.f ++;

        if (this.f >= this.framesToSlowDown) { 

            this.scrollingSpeed *= .975;

            if (this.scrollingSpeed < .4) {

                this.scrolling = false;

                const resultBlockScrollingData = this.getScrollingData(this.resultBlockId);
                
                const dy = Math.abs(resultBlockScrollingData.y - resultBlockScrollingData.py);

                if (dy < 4.5) {
                    this.success = true;
                }
            }
        }
    } 

    public reset(scrollingBlocks: Block[], framesToSlowDown: number): void {

        this.scrolling = true;
        this.blockScrollingData = [];
        this.f = 0;
        this.scrollingSpeed = 0;
        this.framesToSlowDown = framesToSlowDown;
        this.success = false;

        for (let i = 0; i < scrollingBlocks.length; i ++) {

            const data = {
                id: scrollingBlocks[i].blockData.id,
                blockHeight: scrollingBlocks[i].blockHeight,
                y: scrollingBlocks[i].y,
                py: scrollingBlocks[i].py,
            };

            this.blockScrollingData.push(data);
        }
    }

    public getScrollingData(id: number): {id: number, blockHeight: number, y: number, py: number} {

        let data: {id: number, blockHeight: number, y: number, py: number} = null;

        for (let i = 0; i < this.blockScrollingData.length; i ++) {

            if (this.blockScrollingData[i].id === id) {
                data = this.blockScrollingData[i];
                break;
            }
        }  
        
        return data;
    }
}
